import {styled} from 'styled-components';

export const PromoContainer = styled.div`
    margin-top: 24px;
`;
